import { memo } from 'react';
import { Banners } from '@betty/banners';
import { Box } from '@betty/moonlight';
import { useBreakpoint, Breakpoint } from '@betty/moonlight';
import Filters from '../../Filters/Filters';

function CategoriesHeader() {
  const breakpoint = useBreakpoint();

  return (
    <Box gap="space-300">
      {breakpoint === Breakpoint.MOBILE ? (
        <Box>
          <Banners />
        </Box>
      ) : null}
      <Filters />
    </Box>
  );
}

export default memo(CategoriesHeader);
